import React from 'react';
import '../../styles/SolucionesPublicitarias.css';
import cardsData from '../../data/inventorySegmentations.json';

const InventorySegmentations = () => {
    return (
        <section className="inventory-segmentations-section py-5">
            <div className="container">
                {/* Título */}
                <div className="title-container" data-aos="fade-up">
                    <h2 className="title"><span>Inventario y </span>segmentaciones</h2>
                    <div className="title-underline"></div>
                </div>

                <div className="section-description" data-aos="fade-up">
                    <p>
                        En BeHealth ofrecemos opciones flexibles y estratégicas para mostrar tus anuncios, 
                        adaptándonos a tus objetivos de campaña. Puedes elegir ubicaciones específicas, 
                        desde espacios de alto tráfico como nuestra Home, hasta secciones especializadas 
                        y opciones rotativas en todo el sitio. Maximiza la visibilidad de tu marca 
                        conectándola con las audiencias más relevantes.
                    </p>
                </div>

                <div className='row align-items-start justify-content-center'>
                    {cardsData.map((card, index) => (
                        <div
                            key={index}
                            className='col-lg-4 col-md-6 inventory-segmentations-card justify-content-center align-items-center mt-5 mb-5'
                        >
                            <div className='img-display-mobile' data-aos="flip-right">
                                <img src={card.img} className='img-fluid img-filter' alt={card.title} />
                            </div>
                            <div data-aos="fade-up ">
                                <h4 >{card.title}</h4>
                                <p >{card.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default InventorySegmentations;